import * as React from "react";
const IconChevronLeftCircleCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 3C16 3 3 16 3 32s13 29 29 29 29-13 29-29S48 3 32 3m0 56C17.1 59 5 46.9 5 32S17.1 5 32 5s27 12.1 27 27-12.1 27-27 27" />
    <path d="M39.3 17.8c-.4-.4-1-.4-1.4 0L24.6 31.3c-.4.4-.4 1 0 1.4l13.3 13.5c.2.2.5.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4L26.8 32l12.6-12.8c.3-.4.3-1-.1-1.4" />
  </svg>
);
export default IconChevronLeftCircleCopy;
